import { Bell } from "lucide-react";
import { useTranslation } from "react-i18next";

interface NotificationEmptyStateProps {
	variant: "no-notifications" | "all-caught-up";
}

export function NotificationEmptyState({ variant }: NotificationEmptyStateProps) {
	const { t } = useTranslation("notification");

	return (
		<div className="flex flex-col items-center justify-center gap-3 py-8 text-center">
			<Bell size={32} className="text-foreground/20" />
			<p className="text-sm text-foreground/50">{variant === "all-caught-up" ? t("empty.all_caught_up") : t("empty.no_notifications")}</p>
		</div>
	);
}
